import axiosInstance from 'services/base/axiosInstance';
import { RequestOptionsInterface } from 'model/services/requestOption';
import webStorageClient from 'utils/webStorageClient';
import { message } from 'antd';
import i18n from 'services/i18n';

const getRequest = (
  url: string,
  options?: RequestOptionsInterface
): Promise<object> => {
  const params = options?.params;
  const tokenClient = webStorageClient.getToken();
  const enableFlashMessageSuccess = options?.enableFlashMessageSuccess || false;
  const enableFlashMessageError = options?.enableFlashMessageError || true;
  const messageSuccessCustom = options?.messageSuccessCustom || 'success';

  return axiosInstance
    .get(url, {
      params: params,
      headers: {
        Authorization: `Bearer ${tokenClient}`
      }
    })
    .then((res: any) => {
      if (enableFlashMessageSuccess) {
        if (res?.message) {
          message.success(i18n?.t(`message:${res?.message}`));
        } else {
          message.success(i18n?.t(`message:${messageSuccessCustom}`));
        }
      }
      return res;
    })
    .catch(err => {
      if (enableFlashMessageError && err?.response?.data?.errors?.length > 0) {
        err?.response?.data?.errors?.forEach((mess: string) => {
          message.error(i18n?.t(`message:${mess}`));
        });
      }
      return Promise.reject(err);
    });
};

export { getRequest };
